<template>
  <div id="content">
    <v-card>
      <v-responsive max-height="500">
        <v-img
          class="white--text"
          :src="banner"
          max-height="500"
          gradient="to top, rgba(100,100,100,.33), rgba(0,0,0,.54)"
        >
          <v-layout fill-height justify-center align-center>
            <h1 class="banner-title">Resources</h1>
          </v-layout>
        </v-img>
      </v-responsive>
    </v-card>

    <!-- devotional -->
    <v-container>
      <div class="text-xs-left my-4">
        <h3 class="section-title">Devotional</h3>
        <v-divider class="grey"></v-divider>
      </div>
      <blockquote v-if="devotional.body !== ''" class="text-xs-center">
        <h1 class="headline">
          "Charles Spurgeon Morning and Evening Devotional"
        </h1>
        <p class="subheading" v-html="devotional.body"></p>
        <span class="caption" v-html="devotional.keyverse"></span>
      </blockquote>
      <v-card v-else height="300" flat>
        <v-layout fill-height align-center>
          <v-flex text-xs-center>
            <v-icon x-large>cloud_off</v-icon>
            <h4 class="display-1 my-2">Unable to load devotional</h4>
            <p class="subheading">
              Something went wrong. Try reloading the page again.
            </p>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>

    <v-container grid-list-lg>
      <div class="text-xs-left my-4">
        <h3 class="section-title">Downloadables</h3>
        <v-divider class="grey"></v-divider>
      </div>

      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-card>
            <v-list subheader>
              <v-subheader>PDFs</v-subheader>

              <v-list-tile
                v-for="item in pdfs"
                :key="item.title"
                avatar
                @click="downloadPdf(item.file)"
              >
                <v-list-tile-avatar>
                  <v-icon :class="[item.iconClass]">fa-{{ item.icon }}</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6>
          <v-card>
            <v-list subheader>
              <v-subheader>Forms</v-subheader>

              <v-list-tile
                v-for="item in forms"
                :key="item.title"
                avatar
                @click="downloadPdf(item.file)"
              >
                <v-list-tile-avatar>
                  <v-icon :class="[item.iconClass]">fa-{{ item.icon }}</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import AuthenticationService from "@/services/AuthenticationService";
import DownloadMixin from "@/mixins/downloadMixin";
export default {
  name: "Resources",
  data() {
    return {
      banner: require("../assets/banner/resources-banner.jpg"),
      forms: [
        {
          icon: "file-alt",
          iconClass: "blue white--text",
          file: "Form - Counseling Form.pdf",
          title: "Counseling Form"
        },
        {
          icon: "file-alt",
          iconClass: "blue white--text",
          file: "Form - Sample Devotional Journal.pdf",
          title: "Sample Devotional Journal"
        },
        {
          icon: "file-alt",
          iconClass: "blue white--text",
          file: "Form - UCCC Visitation Form.pdf",
          title: "UCCC Visitation Form"
        },
        {
          icon: "file-alt",
          iconClass: "blue white--text",
          file: "Form - UCCC Water Baptism Form.pdf",
          title: "UCCC Water Baptism Form"
        },
        {
          icon: "file-alt",
          iconClass: "blue white--text",
          file: "Form - Wake Service Request Form.pdf",
          title: "Wake Service Request Form"
        }
      ],
      pdfs: [
        {
          icon: "file-pdf",
          iconClass: "red white--text",
          file: "An Invitation to Support Brochure.pdf",
          title: "An Invitation to Support Brochure"
        },
        {
          icon: "file-pdf",
          iconClass: "red white--text",
          file: "Billy and Grace Info.pdf",
          title: "Billy and Grace Info"
        },
        {
          icon: "file-pdf",
          iconClass: "red white--text",
          file: "Hemady Worship Service.pdf",
          title: "Hemady Worship Service"
        },
        {
          icon: "file-pdf",
          iconClass: "red white--text",
          file: "Sunday-Service-Jan-to-May.pdf",
          title: "Sunday Service Jan to May"
        },
        {
          icon: "file-pdf",
          iconClass: "red white--text",
          file: "Sunday-Service-Jun-to-Sept.pdf",
          title: "Sunday Service Jun to Sept"
        },
        {
          icon: "file-pdf",
          iconClass: "red white--text",
          file: "Sunday-Service-Oct-to-Dec.pdf",
          title: "Sunday Service Oct to Dec"
        },
        {
          icon: "file-pdf",
          iconClass: "red white--text",
          file: "The Shorter Catechism in Modern English.pdf",
          title: "The Shorter Catechism in Modern English"
        },
        {
          icon: "file-pdf",
          iconClass: "red white--text",
          file: "UCC Church History.pdf",
          title: "UCC Church History"
        }
      ],
      devotional: {
        body: "",
        keyverse: ""
      }
    };
  },
  mounted() {
    this.getDailyDevotional();
  },
  methods: {
    async getDailyDevotional() {
      const response = await AuthenticationService.getDailyDevotional();
      if (response.data) {
        this.devotional.body = response.data.body;
        this.devotional.keyverse = response.data.keyverse;
      }
    },
    downloadPdf(file) {
      let url = `${process.env.SERVER_URI}/resources/pdfs/${file}`;
      this.download(url);
    }
  },
  mixins: [DownloadMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.book {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 112px;
  /* height: 150px; */
  /* padding: 8px 4px; */
  box-sizing: border-box;
  margin: 24px auto 40px;
  text-align: center;
  position: relative;
  box-shadow: 36px 0 0 0 #fff, -36px 0 0 0 #fff, 24px 4px 4px -8px #333,
    -24px 4px 4px -8px #333, 0 24px 40px -20px #777;
}
</style>


// WEBPACK FOOTER //
// src/components/Resources.vue